import { createContext, useContext } from 'react';
import { noop } from 'lodash-es';

export const AnimationScheduleContext = createContext({
  requestAnimation: () => ({ delay: 0, endAt: 0 }),
});

export const useAnimationSchedule = () => useContext(AnimationScheduleContext);

export const RevealBoundaryContext = createContext({
  reportRevealLeaf: noop,
});

export const useRevealBoundary = () => useContext(RevealBoundaryContext);
